/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Type_ArchiveInputs */

const en_media_type_archive = /** @type {(inputs: Media_Type_ArchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secure Zip`)
};

const id_media_type_archive = /** @type {(inputs: Media_Type_ArchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zip Aman`)
};

/** @type {(inputs: Media_Type_ArchiveInputs) => LocalizedString} */
const es_media_type_archive = en_media_type_archive;

/** @type {(inputs: Media_Type_ArchiveInputs) => LocalizedString} */
const fr_media_type_archive = en_media_type_archive;

/** @type {(inputs: Media_Type_ArchiveInputs) => LocalizedString} */
const de_media_type_archive = en_media_type_archive;

/** @type {(inputs: Media_Type_ArchiveInputs) => LocalizedString} */
const ja_media_type_archive = en_media_type_archive;

/** @type {(inputs: Media_Type_ArchiveInputs) => LocalizedString} */
const zh_media_type_archive = en_media_type_archive;

/** @type {(inputs: Media_Type_ArchiveInputs) => LocalizedString} */
const ar_media_type_archive = en_media_type_archive;

/** @type {(inputs: Media_Type_ArchiveInputs) => LocalizedString} */
const it_media_type_archive = en_media_type_archive;

/** @type {(inputs: Media_Type_ArchiveInputs) => LocalizedString} */
const ru_media_type_archive = en_media_type_archive;

/** @type {(inputs: Media_Type_ArchiveInputs) => LocalizedString} */
const pt_media_type_archive = en_media_type_archive;

/** @type {(inputs: Media_Type_ArchiveInputs) => LocalizedString} */
const ko_media_type_archive = en_media_type_archive;

/**
* | output |
* | --- |
* | "Secure Zip" |
*
* @param {Media_Type_ArchiveInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const media_type_archive = /** @type {((inputs?: Media_Type_ArchiveInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Type_ArchiveInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_media_type_archive(inputs)
	if (locale === "es") return es_media_type_archive(inputs)
	if (locale === "fr") return fr_media_type_archive(inputs)
	if (locale === "de") return de_media_type_archive(inputs)
	if (locale === "ja") return ja_media_type_archive(inputs)
	if (locale === "zh") return zh_media_type_archive(inputs)
	if (locale === "ar") return ar_media_type_archive(inputs)
	if (locale === "id") return id_media_type_archive(inputs)
	if (locale === "it") return it_media_type_archive(inputs)
	if (locale === "ru") return ru_media_type_archive(inputs)
	if (locale === "pt") return pt_media_type_archive(inputs)
	return ko_media_type_archive(inputs)
});